import APIDOC from "./serverApi";
import {get, post} from "./request";
const THESIS=APIDOC.THESIS;
const PAYMENT = APIDOC.PAYMENT;


//支付相关==>
export const getPayList = params => get(PAYMENT.list);//分页查询在线支付列表
export const getStudentPayInfo = studentId => get(PAYMENT.studentPayInfo,{studentId});//根据学生id查询学生时是否缴费
export const downloadPayList = (params,config)=>get(PAYMENT.payStatus,params,config);//导出在线支付列表
export const getWeChatPayQRCode = outTradeNo=>post(PAYMENT.weChatPayQRCode,{outTradeNo});//生成微信支付二维码
export const getAliPayQRCode = outTradeNo=>post(PAYMENT.aliPayQRCode,{outTradeNo});//生成支付宝支付二维码
export const getOnlinePrice = ()=>get(PAYMENT.payPrice);//获取缴费金额

export const createPayId = ()=>post(PAYMENT.createNum);//创建支付订单号


/* 评论支付 */
export const getWeChatPayQRCodec = outTradeNo=>post(THESIS.getWeChatPayQRCodec,{outTradeNo});//评论生成微信支付二维码
export const getAliPayQRCodec = outTradeNo=>post(THESIS.getAliPayQRCodec,{outTradeNo});//生成支付宝支付二维码
export const creatOrder = outTradeNo=>post(THESIS.creatOrder,{outTradeNo}); //创建订单号
export const getThesisPlagiarismPrice = ()=>post(THESIS.getThesisPlagiarismPrice,{}); //创建订单号
export const getPayDetailByOrderId = outTradeNo => get(THESIS.getPayDetailByOrderId,{outTradeNo});//根据订单id查询订单信息



// WEBPACK FOOTER //
// ./src/common/services.js